import { createServerFn } from "@tanstack/react-start";
import process from "node:process";

// Exposes the EXTERNAL Supabase URL + anon key to the browser.
// Anon keys are designed to be public — they enforce only what RLS allows.
export const getPublicConfig = createServerFn({ method: "GET" }).handler(async () => {
  const url = process.env.EXT_SUPABASE_URL;
  const anonKey = process.env.EXT_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    throw new Error(
      "Missing EXT_SUPABASE_URL / EXT_SUPABASE_ANON_KEY. Add them in Project Settings → Secrets.",
    );
  }
  return { supabaseUrl: url, supabaseAnonKey: anonKey };
});
